import { createFileRoute } from '@tanstack/react-router';

import { MessagesPage } from '../../portal/messages-page';

/** `/account/messages` — the delivery log for what the clinic sent (FR-NOTIF-08). */
export const Route = createFileRoute('/account/messages')({
  component: MessagesPage,
});
